<template>
  <div class="grafico-salas">
    <PainelHeader />

    <main class="grafico-salas__content">
      <button type="button" class="grafico-salas__back" @click="goBack">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M10 3L5 8l5 5V3z"/>
        </svg>
        Voltar
      </button>

      <section class="grafico-salas__panel">
        <PainelSearchFilter
          name="grafico"
          :search.sync="search"
          :selected-cliente-id.sync="selectedClienteId"
          :is-admin="isAdmin"
          :clientes="clientes"
          :refreshing="refreshing"
          @cliente-change="loadSalas"
          @refresh="refreshSalas"
        />

        <div v-if="loading" class="grafico-salas__state">Carregando salas...</div>
        <div v-else-if="loadFailed" class="grafico-salas__state grafico-salas__state--error">
          <p>Não foi possível carregar as salas.</p>
          <button type="button" @click="loadSalas">Tentar novamente</button>
        </div>

        <PainelSalasTable
          v-else
          action-type="graph"
          :rows="filteredRows"
          :columns="tableColumns"
          @action="abrirGrafico"
        />
      </section>
    </main>

    <ModalGraficoSala
      :aberto="modalGraficoAberto"
      :sala-id="modalSala.id"
      :nome-sala="modalSala.protocolo"
      :uid-primario="modalSala.uidPrimario"
      :uid-secundario="modalSala.uidSecundario"
      @fechar="fecharModalGrafico"
    />
  </div>
</template>

<script>
import PainelHeader from '../components/PainelHeader.vue';
import PainelSearchFilter from '../components/PainelSearchFilter.vue';
import PainelSalasTable from '../components/PainelSalasTable.vue';
import ModalGraficoSala from '../components/ModalGraficoSala.vue';
import { listarClientes } from '../service/clientes.service';
import { carregarSalasPainel } from '../service/salas-list.service';
import { getClienteId, isAdminCliente, logout } from '../service/auth.service';
import { mapSalaRow, filterSalasBySearch, withClienteColumn } from '../utils/salas.utils';
import { showErrorToast } from '../service/toast.service';

const TABLE_COLUMNS = [
  { key: 'protocolo', label: 'Protocolo' },
  { key: 'status', label: 'Status atual' },
  { key: 'primario', label: 'Primário' },
  { key: 'nomePrimario', label: 'Nome primário' },
  { key: 'secundario', label: 'Secundário' },
  { key: 'nomeSecundario', label: 'Nome secundário' },
  { key: 'duracaoEspera', label: 'Duração da espera' },
  { key: 'duracaoChamada', label: 'Duração da chamada' },
  { key: 'atualizadoEm', label: 'Atualizado em' },
  { key: 'criadoEm', label: 'Criado em' }
];

export default {
  name: 'GraficoSalas',

  components: {
    PainelHeader,
    PainelSearchFilter,
    PainelSalasTable,
    ModalGraficoSala
  },

  data() {
    return {
      rows: [],
      clientes: [],
      search: '',
      selectedClienteId: '',
      isAdmin: isAdminCliente(),
      loading: false,
      refreshing: false,
      loadFailed: false,
      modalGraficoAberto: false,
      modalSala: {
        id: null,
        protocolo: '',
        uidPrimario: '',
        uidSecundario: ''
      }
    };
  },

  computed: {
    tableColumns() {
      return withClienteColumn(TABLE_COLUMNS, this.isAdmin);
    },

    filteredRows() {
      return filterSalasBySearch(this.rows, this.search);
    }
  },

  mounted() {
    if (this.isAdmin) {
      this.loadClientes();
    }

    this.loadSalas();
  },

  methods: {
    goBack() {
      this.$router.push('/painel/dashboard');
    },

    async loadClientes() {
      try {
        this.clientes = await listarClientes();
      } catch (err) {
        showErrorToast('Não foi possível carregar a lista de clientes.');
      }
    },

    async loadSalas() {
      this.loading = true;
      this.loadFailed = false;

      const clienteId = getClienteId();
      if (!clienteId) {
        logout();
        this.$router.push('/painel');
        return;
      }

      try {
        const salas = await carregarSalasPainel({
          isAdmin: this.isAdmin,
          selectedClienteId: this.selectedClienteId,
          clienteId
        });

        this.rows = (salas || []).map(mapSalaRow);
      } catch (err) {
        showErrorToast('Não foi possível carregar as salas. Tente novamente em instantes.');
        this.loadFailed = true;
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },

    async refreshSalas() {
      if (this.loading || this.refreshing) {
        return;
      }

      const clienteId = getClienteId();
      if (!clienteId) {
        logout();
        this.$router.push('/painel');
        return;
      }

      this.refreshing = true;

      try {
        const salas = await carregarSalasPainel({
          isAdmin: this.isAdmin,
          selectedClienteId: this.selectedClienteId,
          clienteId
        });

        this.rows = (salas || []).map(mapSalaRow);
        this.loadFailed = false;
      } catch (err) {
        showErrorToast('Não foi possível atualizar as salas. Tente novamente em instantes.');
      } finally {
        this.refreshing = false;
      }
    },

    abrirGrafico(row) {
      this.modalSala = {
        id: row.id,
        protocolo: row.protocolo,
        uidPrimario: row.uidPrimario,
        uidSecundario: row.uidSecundario
      };
      this.modalGraficoAberto = true;
    },

    fecharModalGrafico() {
      this.modalGraficoAberto = false;
      this.modalSala = {
        id: null,
        protocolo: '',
        uidPrimario: '',
        uidSecundario: ''
      };
    }
  }
};
</script>

<style scoped src="./GraficoSalas.css"></style>
